import { Component, signal } from '@angular/core';
import { SectionHeadingComponent } from '../../ui/section-heading/section-heading.component';
import { ContactFormComponent } from '../../ui/contact-form/contact-form.component';

@Component({
  selector: 'app-contact-section',
  standalone: true,
  imports: [SectionHeadingComponent, ContactFormComponent],
  templateUrl: './contact-section.component.html',
  styleUrl: './contact-section.component.scss',
})
export class ContactSectionComponent {
  readonly copied = signal(false);
  private copyTimer: ReturnType<typeof setTimeout> | null = null;

  copyEmail() {
    navigator.clipboard.writeText('kontakt@weselelive.pl').then(() => {
      this.copied.set(true);
      if (this.copyTimer) clearTimeout(this.copyTimer);
      this.copyTimer = setTimeout(() => this.copied.set(false), 2000);
    });
  }
}
